import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../commonButton";
import withModal from "../../withModal";
import { useToast } from "../../../context/TostContext";
import InputField from "../../form/InputField";

const CompanyServiceModalInner = ({ onClose, onSubmit, service, isLoading }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });
const toast=useToast();
  useEffect(() => {
    if (service) {
      setFormData({
        title: service.title || service.name || "",
        description: service.description || "",
      });
    } else {
      setFormData({
        title: "",
        description: "",
      });
    }
  }, [service]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!formData.title) {
      toast.error("Please enter a service title");
      return;
    }

    const submitData = new FormData();
    submitData.append("title", formData.title);
    submitData.append("description", formData.description);

    onSubmit(submitData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Modal.Body className="grid row-gap-3">
        <InputField
          className="g-col-12"
          label={{ name: "Title" }}
          required
          input={{
            type: "text",
            name: "title",
            value: formData.title,
            onChange: handleChange,
            placeholder: "Ex: Architectural Consultation",
            required: true,
          }}
        />
        <InputField
          className="g-col-12"
          label={{ name: "Description" }}
          input={{
            as: "textarea",
            rows: 4,
            name: "description",
            value: formData.description,
            onChange: handleChange,
            placeholder: "Describe what's included in this service...",
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <CommonButton
          type="button"
          variant="outline"
          title="Cancel"
          onClick={onClose}
          disabled={isLoading}
        />
        <CommonButton
          type="submit"
          variant="primary"
          title={service ? "Update" : "Save"}
          isLoading={isLoading}
        />
      </Modal.Footer>
    </Form>
  );
};

export default withModal(CompanyServiceModalInner);

